import axios from 'axios';

const API_BASE_URL = `${import.meta.env.VITE_API_URL ?? ''}/api`;

interface Contact {
  id: string;
  firstName: string;
  lastName: string;
  name?: string;
  email: string;
  phone?: string;
  role?: string;
  accountId?: string;
  account_id?: string;
}

interface GetContactsParams {
  limit?: number;
  offset?: number;
  search?: string;
  accountId?: string;
  account_id?: string; // backend filters by this (snake_case) query param
}

interface GetContactsResponse {
  data: Contact[];
  total: number;
}

export const contactsService = {
  async getContacts(params?: GetContactsParams): Promise<GetContactsResponse> {
    try {
      const response = await axios.get(`${API_BASE_URL}/contacts`, {
        params,
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('accessToken')}`,
        },
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching contacts:', error);
      throw error;
    }
  },

  async getContactById(id: string): Promise<Contact> {
    try {
      const response = await axios.get(`${API_BASE_URL}/contacts/${id}`, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('accessToken')}`,
        },
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching contact:', error);
      throw error;
    }
  },

  async createContact(contactData: Partial<Contact>): Promise<Contact> {
    try {
      const response = await axios.post(`${API_BASE_URL}/contacts`, contactData, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('accessToken')}`,
        },
      });
      return response.data;
    } catch (error) {
      console.error('Error creating contact:', error);
      throw error;
    }
  },

  async updateContact(id: string, contactData: Partial<Contact>): Promise<Contact> {
    try {
      const response = await axios.put(`${API_BASE_URL}/contacts/${id}`, contactData, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('accessToken')}`,
        },
      });
      return response.data;
    } catch (error) {
      console.error('Error updating contact:', error);
      throw error;
    }
  },

  async deleteContact(id: string): Promise<void> {
    try {
      await axios.delete(`${API_BASE_URL}/contacts/${id}`, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('accessToken')}`,
        },
      });
    } catch (error) {
      console.error('Error deleting contact:', error);
      throw error;
    }
  },
};
